export default __webpack_public_path__ + "static/media/airdockz-bpk-1.bc2d8dd3.png";